import definition from '@client/config/definition';
import * as corosSportConfig from '@coros/sport-config';
import { SportMode } from '@mytypes/activity-detail/ApiModel/SportMode';
import { Ref } from 'vue';
import { LapItem } from '@mytypes/activity-detail/LapList';
import { lapListTypeIsLap } from '../hooks/useLapSelectValue';
const { isIndoorClimbOrBoulderingTrainingSportName } = corosSportConfig.sport.climb;

/* 圈数表序号相关begin-------------------------------> */
// sportMode = 1，圈数用 lapTrainIndex
// sportMode = 0，圈数用 lapIndex
// sportMode = 6，圈数用 exerciseIndex-setIndex
// sportMode = 6，动作序号用 exerciseIndex

type Option = {
  isProgram: boolean;
  sportMode: SportMode;
  data: LapItem;
  sportName: string;
  index: number;
  listData: any;
};

type Inject = {
  isAllDistanceRef: Ref<boolean>;
  hasPostureTest?: Ref<boolean>;
};

// 获取圈速表中数据的序号
/**
 * @deprecated 已经废弃
 */
export function getActivityIndex(option: Option, inject: Inject) {
  const { isProgram = false, sportMode = SportMode.NORMAL } = option;
  const { isAllDistanceRef } = inject;

  if (isAllDistanceRef.value) {
    return '1';
  }

  // console.log(`getActivityIndex`, isProgram, sportMode);
  if (isProgram) {
    // 训练课程
    return getIndexForProgramSport(option);
  } else if (sportMode === SportMode.INTERVAL) {
    // 间歇训练
    return getIndexForIntervalSport(option);
  } else {
    // 其他普通运动
    return getIndexForBasicSport(option);
  }
}

// 获取训练组合详情的圈速表序号
export function getIndexForProgramSport(option: Option) {
  const { data, sportName } = option;

  if (!lapListTypeIsLap.value && !data.exerciseIndex) {
    return '';
  }

  if (data.indexInOriginLap) {
    return '';
  }

  // mode为休息一定是休息
  if (!definition.isExerciseMode(data.mode) && !definition.isWarmupMode(data.mode)) {
    return '';
  }

  if (isIndoorClimbOrBoulderingTrainingSportName(sportName)) {
    return data.setIndex <= 1 ? data.exerciseIndex : '';
  }

  if (data.exerciseIndex && data.setIndex) {
    return `${data.exerciseIndex}-${data.setIndex}`;
  }

  return data.exerciseIndex || '';
}

// 获取间歇运动详情的圈速表序号
export function getIndexForIntervalSport(option: Option) {
  // listData 是 ref
  const { listData, data, index = 0 } = option;

  if (lapListTypeIsLap.value) {
    return data.lapTrainIndex || '';
  }
  if (data.indexInOriginLap > 0) return '';

  if (data.indexInOriginLap === 0 && data.lapTrainIndex) {
    let resultIndex = 0;
    for (let n = 0, length = listData.value.length; n < length; n++) {
      const item = listData.value[n];
      if (item.indexInOriginLap === 0 && item.lapTrainIndex) {
        resultIndex++;
      }
      if (index === n) {
        break;
      }
    }
    return resultIndex;
  }

  return '';
}

// 获取普通运动详情的圈速表序号
export function getIndexForBasicSport(option: Option) {
  // listData 是 ref
  const { listData, data, index = 0, sportName } = option;

  // 部分运动需要特殊处理
  // 健身
  if (['Strength'].includes(sportName)) {
    if (definition.isRestMode(data.mode)) {
      return '';
    }
    return data.exerciseIndex || '';
  }

  // 登山滑雪（新）
  if (['Ski_Touring'].includes(sportName)) {
    if (![3, 4].includes(data.lapListType)) {
      if (!data.sectionIndex || ![1, '1'].includes(data.rowIndex)) {
        return '';
      }
    }
    return data.sectionIndex || '';
  }

  // 登山滑雪（旧）
  if (['Ski_Touring_Old'].includes(sportName)) {
    return index + 1;
  }

  // 攀登
  if (['Climb'].includes(sportName)) {
    const lastData = listData.value[index - 1];
    const first = ((lastData && lastData.rowIndex) || 0) + 1;
    const second = data.rowIndex || '';

    if (!second) {
      return '';
    } else if (first === second) {
      return second;
    } else {
      return `${first}-${second}`;
    }
  }

  // 组合运动、铁人三项
  if (['Multi_Sport', 'Triathlon', 'Multi_Pitch'].includes(sportName)) {
    return `${index + 1}`;
  }

  // 跳绳
  if (['Jump_Rope'].includes(sportName)) {
    if (definition.isRestMode(data.mode)) {
      return '';
    }

    let resultIndex = 1;
    for (let n = 0, length = listData.value.length; n < length; n++) {
      if (n === index) {
        break;
      }

      if (definition.isRestMode(listData.value[n].mode)) {
        continue;
      }

      resultIndex++;
    }

    return resultIndex;
  }

  return data.lapIndex || '';
}
